import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@material-ui/core';

/**
 * Dialogue de confirmation de suppression
 */
const DeleteDialog = ({ open, deleteType, onConfirm, onCancel }) => {
  const getMessage = () => {
    if (deleteType === 'f') return 'Supprimer définitivement ce mouvement fournisseur ?';
    if (deleteType === 'c') return 'Supprimer définitivement ce mouvement client ?';
    if (deleteType === 'clal') return 'Supprimer définitivement ce mouvement CLAL ?';
    return 'Supprimer cet élément ?';
  };

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle style={{ fontSize: '1.05rem', fontWeight: 600 }}>
        Confirmer la suppression
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" style={{ lineHeight: 1.5 }}>
          {getMessage()}
        </Typography>
        <Typography variant="caption" style={{ display: 'block', marginTop: 8, opacity: .7 }}>
          Cette action est irréversible.
        </Typography>
      </DialogContent>
      <DialogActions style={{ padding: '8px 16px 16px' }}>
        <Button onClick={onCancel} size="small">
          Annuler
        </Button>
        <Button onClick={onConfirm} color="secondary" variant="contained" size="small">
          Supprimer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DeleteDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  deleteType: PropTypes.oneOf(['f', 'c', 'clal']),
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};

export default DeleteDialog;
